import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IPopulate,
  IQueryParam,
  IActivo,
  IFilter,
  IReporteBase,
  IReporteGenerico,
  IListado,
  IEventoGenerico,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { ActivosService } from '../../../../../auxiliares/servicios/http/activos.service';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import { CrearEditarActivoComponent } from '../crear-editar-activo/crear-editar-activo.component';
import { Router } from '@angular/router';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { MapaFacilDialogComponent } from '../../../../../auxiliares/mapa-facil-dialog/mapa-facil-dialog.component';
import {
  MapaFacilData,
  Coordinate,
} from '../../../../../auxiliares/mapa-facil/interfaces';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { isModoDesactivadoActivo } from '../../../../../auxiliares/modo-desactivado.util';
import { LoginService } from '../../../../login/login.service';
import { ModoDesactivadoDispositivoComponent } from '../../../../standalone/modo-desactivado-dispositivo/modo-desactivado-dispositivo.component';
import { CambiarClienteComponent } from '../../../../standalone/cambiar-cliente/cambiar-cliente.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { CrearEditarEstadoCuentaComponent } from '../../../administracion/estado-entidad/crear-editar-estado-cuenta/crear-editar-estado-cuenta.component';
import {
  CrearEditarEventoTecnicoGenericoComponent,
  ICrearEditarEventoTecnicoGenericoData,
} from '../../../eventos-genericos/eventos-tecnicos-genericos/crear-editar/crear-editar-evento-tecnico-generico.component';
import { EventosGenericosHttpService } from '../../../../../auxiliares/servicios/http/eventos-genericos.service';
import { ReportesGenericosService } from '../../../../../auxiliares/servicios/http/reportes-genericos.service';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';
import {
  estadoConexionCelda,
  estadoHtml,
  fechaCelda,
  haceCelda,
} from '../../../../../auxiliares/tabla/celdas';

interface IActivoTabla extends IActivo {
  ultimoReporte?: IReporteBase<
    'Tracker 4G' | 'Tracker Qualcomm' | 'Tracker T1000B'
  >;
  color?: string;
}

@Component({
  selector: 'app-listado-activos',
  templateUrl: './listado-activos.component.html',
  styleUrl: './listado-activos.component.scss',
  standalone: false,
})
export class ListadoActivosComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ActivosService);
  private formularios = inject(FormularioDialogService);
  private navigator = inject(Router);
  private eventosService = inject(EventosGenericosHttpService);
  private reportesService = inject(ReportesGenericosService);

  public clientePropio = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoActivosComponent';
  public activos?: IActivoTabla[];
  public totalCount = 0;
  public columnas?: IColumnas<IActivoTabla>[];
  public reportes: (
    | IReporteBase<'Tracker 4G'>
    | IReporteBase<'Tracker T1000B'>
    | IReporteBase<'Tracker Qualcomm'>
  )[] = [];

  //Subs
  public reportes$?: Subscription;
  public activos$?: Subscription;
  //

  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Activos - Crear'),
    tooltip: 'Crear activo',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };
  public search: IRegExpSearch = {
    fields: ['identificacion'],
  };
  // FILTROS
  public filter: IFilter<IActivo> = {};
  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'tracker',
      select: 'nombre identificacion tipo idModelo frecReporte',
      populate: { path: 'modelo', populate: { path: 'codigos' } },
    },
  ];
  public tracker: IFiltroTabla = {
    filter: {
      field: 'idTracker',
    },
    label: 'Tracker',
    tipo: 'tracker-selector',
  };
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    filtroSelector: ['moduloActivos'],
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public filtros: IFiltroTabla[] = [this.tracker];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };
  // Listars
  public async listar(): Promise<void> {
    this.activos$?.unsubscribe();
    this.activos$ = this.lista2
      .activos(this.query, 30)
      .subscribe(async (data) => {
        await this.completaUltimoReporte(data);
        // Total del backend, no el largo de la página: con el largo el
        // paginador quedaba en "0 de 0" y no se podía pasar de la primera.
        this.totalCount = data.totalCount;
      });
  }
  public async completaUltimoReporte(
    listado: IListado<IActivoTabla>,
  ): Promise<void> {
    if (!listado.datos.length) {
      this.activos = [];
      return;
    }
    const idsActivos = listado.datos.map((v) => v._id);
    const filter: IFilter<IReporteGenerico> = {
      idsAsignados: { $in: idsActivos },
    };
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: '-fechaCreacion',
      includeChildren: true,
    };

    this.reportes$?.unsubscribe();
    this.reportes$ = this.lista2
      .ultimosReportesGenericos<
        'Tracker 4G' | 'Tracker T1000B' | 'Tracker Qualcomm'
      >(query)
      .subscribe((data) => {
        for (const activo of listado.datos) {
          const findReporte = data.datos.find((r) =>
            r.idsAsignados?.includes(activo._id!),
          );
          activo.ultimoReporte = findReporte;
          if (activo.ultimoReporte) {
            const frecuenciaReporte = activo?.tracker?.frecReporte;
            const timeReporte = new Date(
              activo.ultimoReporte.fechaCreacion,
            ).getTime();
            const timeNow = new Date().getTime();
            const diff = timeNow - timeReporte;
            const frecuenciaEnMs = frecuenciaReporte * 60 * 1000;
            if (diff > 2 * frecuenciaEnMs) {
              activo.color = 'red';
            } else if (diff > frecuenciaEnMs && diff < 2 * frecuenciaEnMs) {
              activo.color = 'yellow';
            } else if (diff < frecuenciaEnMs) {
              activo.color = 'green';
            } else {
              activo.color = 'black';
            }
          }
        }
        this.activos = listado.datos;
      });
  }

  // Acciones

  public async ubicar(c: IActivoTabla) {
    if (!c.ultimoReporte?.valores?.geojson?.coordinates) return;
    const coord: Coordinate = [
      c.ultimoReporte?.valores?.geojson?.coordinates[0],
      c.ultimoReporte?.valores?.geojson?.coordinates[1],
    ];
    const data: MapaFacilData = {
      markers: [{ coor: coord, label: 'vehiculo' }],
    };
    this.formularios.abrir(MapaFacilDialogComponent, {
      tamano: 'grande',
      data,
      cerrarAfuera: true,
    });
  }

  public crear() {
    const res = this.formularios.abrir(CrearEditarActivoComponent, {
      tamano: 'mediano',
      data: {
        tipo: 'Normal',
      },
    });
    res.afterClosed().subscribe(async (res) => {
      if (res) {
        await this.listar();
      }
    });
  }

  public async modoDesactivado(activo: IActivo) {
    this.formularios.abrir(ModoDesactivadoDispositivoComponent, {
      tamano: 'chico',
      data: { activo: activo },
    });
  }

  public async crearEstadoEntidad(activo: IActivo) {
    this.formularios.abrir(CrearEditarEstadoCuentaComponent, {
      tamano: 'chico',
      data: { activo },
    });
  }

  public async editar(activo: IActivo) {
    const res = this.formularios.abrir(CrearEditarActivoComponent, {
      tamano: 'mediano',
      data: {
        edit: activo,
        tipo: 'Normal',
      },
    });
    res.afterClosed().subscribe(async (res) => {
      if (res) {
        await this.listar();
      }
    });
  }

  public async exportarEventos(activo: IActivo) {
    const rango = await this.dialogService.dateRange(
      'Exportar Eventos',
      'Seleccioná el rango de fechas para exportar los eventos',
    );
    if (!rango) return;

    const filter: IFilter<IEventoGenerico> = {
      idEntidad: activo._id,
      fechaCreacion: {
        $gte: rango?.start,
        $lte: rango?.end,
      },
    };

    const populate: IPopulate[] = [
      {
        path: 'activo',
        select: 'identificacion',
      },
      {
        path: 'cliente',
        select: 'nombre',
      },
    ];

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'fechaCreacion',
      page: 0,
      limit: 0,
      unlimited: true,
      includeChildren: true,
      populate: JSON.stringify(populate),
    };

    const config = {
      columns: [
        {
          header: 'Fecha',
          key: 'fechaCreacion',
          transform: 'fechaHora' as const,
        },
        {
          header: 'Cliente',
          key: 'cliente.nombre',
        },
        {
          header: 'Categoría',
          key: 'categoria',
          placeholder: 'Sin categoría',
        },
        {
          header: 'Entidad',
          key: 'activo.identificacion',
        },
        {
          header: 'Tipo Evento',
          key: 'tipoEvento',
        },
        {
          header: 'Estado',
          key: 'estado',
        },
        {
          header: 'Evento',
          key: 'valores.titulo',
          placeholder: 'Sin título',
        },
        {
          header: 'Detalles',
          key: 'valores.mensaje',
          placeholder: 'Sin detalles',
        },
        {
          header: 'Fecha Evento',
          key: 'valores.timestamp',
          transform: 'fechaHora' as const,
        },
      ],
      sheetName: 'Eventos',
      autoFilter: true,
    };

    try {
      await this.eventosService.exportar(query, config, activo.identificacion);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async exportarReportes(activo: IActivo) {
    const rango = await this.dialogService.dateRange(
      'Exportar Reportes',
      'Seleccioná el rango de fechas para exportar los reportes',
    );
    if (!rango) return;

    const filter: IFilter<IReporteGenerico> = {
      idsAsignados: activo._id,
      tipoReporte: {
        $in: ['Tracker 4G', 'Tracker T1000B', 'Tracker Qualcomm'],
      },
      fechaCreacion: {
        $gte: rango?.start,
        $lte: rango?.end,
      },
    };

    const populate: IPopulate[] = [
      {
        path: 'activo',
        select: 'identificacion',
      },
      {
        path: 'cliente',
        select: 'nombre',
      },
    ];

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'fechaCreacion',
      page: 0,
      limit: 0,
      unlimited: true,
      includeChildren: true,
      populate: JSON.stringify(populate),
    };

    const config = {
      columns: [
        {
          header: 'Fecha',
          key: 'fechaCreacion',
          transform: 'fechaHora' as const,
        },
        {
          header: 'Cliente',
          key: 'cliente.nombre',
        },
        {
          header: 'Activo',
          key: 'activo.identificacion',
        },
        {
          header: 'Fecha Device',
          key: 'valores.fechaDevice',
          transform: 'fechaHora' as const,
        },
        {
          header: 'Latitud',
          key: 'valores.geojson.coordinates.1',
          placeholder: '-',
        },
        {
          header: 'Longitud',
          key: 'valores.geojson.coordinates.0',
          placeholder: '-',
        },
        {
          header: 'Velocidad (km/h)',
          key: 'valores.velocidad',
          transform: 'velocidad' as const,
          placeholder: '0',
        },
        {
          header: 'Orientación',
          key: 'valores.orientacion',
          transform: 'orientacionBrujula' as const,
          placeholder: '-',
        },
        {
          header: 'Ignición',
          key: 'valores.ignicion',
          transform: 'booleanSiNo' as const,
          placeholder: '-',
        },
        {
          header: 'Odómetro (km)',
          key: 'valores.odometro',
          transform: 'kilometros' as const,
          placeholder: '0',
        },
        {
          header: 'Estado Tripero',
          key: 'valores.triperoState',
          placeholder: 'Desconocido',
        },
        {
          header: 'Dirección',
          key: 'valores.direccion',
          placeholder: 'Sin dirección',
        },
      ],
      sheetName: 'Reportes',
      autoFilter: true,
    };

    try {
      await this.reportesService.exportar(query, config, activo.identificacion);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public verDetalles(activo: IActivo): void {
    this.navigator.navigate(['main/activos/activos/detalles', activo._id]);
  }

  public async configs(data: IActivo) {
    this.navigator.navigate(
      ['main/administracion/configEventos', data.idTracker],
      {},
    );
  }
  public async cambiarCliente(activo: IActivo) {
    const dialogRef = this.formularios.abrir(CambiarClienteComponent, {
      tamano: 'mediano',
      data: {
        entidad: activo,
        tipoEntidad: 'Activo',
      },
    });
    dialogRef.afterClosed().subscribe(async (resultado) => {
      if (resultado) {
        await this.listar();
      }
    });
  }

  public async eliminar(activo: IActivo) {
    const res = await this.dialogService.confirm(
      'Eliminar Activo',
      `¿Querés eliminar el activo ${activo.identificacion}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(activo._id!);
      this.helper.notifSuccess('Activo eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async eventoTecnico(activo: IActivo) {
    const data: ICrearEditarEventoTecnicoGenericoData = {
      idEntidad: activo._id!,
      tipoEvento: 'Evento Técnico Tracker',
      categoria: 'Tracker',
      idsCQAET: [this.clientePropio!._id!],
    };

    this.formularios.abrir(CrearEditarEventoTecnicoGenericoComponent, {
      tamano: 'grande',
      data,
    });
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<IActivoTabla>[] = [
      // Identificacion
      {
        header: {
          label: 'Identificación',
          sortable: true,
          sort: 'identificacion',
        },
        row: {
          html: (dato) => {
            const badge = isModoDesactivadoActivo(dato.modoDesactivado)
              ? `<span>${estadoHtml({ texto: 'Desactivado', tono: 'neutro', icono: 'do_not_disturb_on' })}</span>`
              : '';
            const nombre = dato.identificacion
              ? `<span class="tabla-principal">${escaparHtml(dato.identificacion)}</span>`
              : `<span class="no-info">Sin identificación</span>`;
            return `<div class="tabla-celda-col">${nombre}${badge}</div>`;
          },
          tooltip: (dato) =>
            isModoDesactivadoActivo(dato.modoDesactivado)
              ? 'Dispositivo desactivado'
              : undefined,
        },
      },
      // Tracker
      {
        header: {
          label: 'Tracker',
        },
        row: {
          parse(dato) {
            return dato.tracker?.nombre;
          },
          noData: 'Sin tracker',
        },
      },
      // Ultima Comunicacion
      {
        header: {
          label: 'Última comunicación',
        },
        row: {
          // Comunicación con el mismo criterio que el detalle (antes era sólo
          // un círculo de color): estado con nombre, fecha y "hace x".
          html: (dato) => {
            const fechaReporte = dato.ultimoReporte?.fechaCreacion;
            let html = `<div class="tabla-celda-col">`;
            html += `<span>${estadoHtml(estadoConexionCelda(fechaReporte, dato.tracker?.frecReporte))}</span>`;
            if (fechaReporte) {
              html += `<span class="tabla-secundario">${fechaCelda(fechaReporte)} · ${haceCelda(fechaReporte)}</span>`;
            }
            html += `</div>`;
            return html;
          },
          tooltip: (dato) =>
            dato.tracker?.frecReporte
              ? `Frecuencia de reporte: ${dato.tracker.frecReporte} min`
              : 'Sin frecuencia de reporte configurada',
        },
      },
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        // Menú: Ver detalle · Editar · Eliminar · Más acciones ▸ (orden de
        // siempre; el submenú se conserva)
        accionesGrouped: [
          // Ver detalle
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.verDetalles(dato),
          },
          // Editar
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () => !this.helper.tienePermiso('Activos - Editar'),
          },
          // Eliminar
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () => !this.helper.tienePermiso('Activos - Eliminar'),
          },
          // Más Acciones
          {
            tipo: 'material',
            color: 'primary',
            icon: 'more_vert',
            tooltip: 'Más acciones',
            children: [
              // Exportar Eventos
              {
                tipo: 'material',
                color: 'primary',
                icon: 'file_download',
                tooltip: 'Exportar eventos',
                click: (dato) => this.exportarEventos(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Activos - Exportar eventos'),
              },
              // Exportar Reportes
              {
                tipo: 'material',
                color: 'primary',
                icon: 'description',
                tooltip: 'Exportar reportes',
                click: (dato) => this.exportarReportes(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Activos - Exportar Reportes'),
              },
              // Servicio Técnico
              {
                tipo: 'material',
                color: 'primary',
                icon: 'build',
                tooltip: 'Servicio técnico',
                click: (dato) => this.eventoTecnico(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Activos - Solicitar servicio técnico',
                  ),
              },
              // Modo Desactivado
              {
                tipo: 'material',
                color: 'primary',
                icon: 'do_not_disturb_on',
                tooltip: 'Modo desactivado',
                click: (dato) => this.modoDesactivado(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Activos - Cambiar modo desactivado',
                  ),
              },
              // Editar Cliente
              {
                tipo: 'material',
                color: 'primary',
                icon: 'drive_file_move',
                tooltip: 'Cambiar de cliente',
                click: (dato) => this.cambiarCliente(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Activos - Cambiar de cliente'),
              },
              // Cambiar estado de cuenta
              {
                tipo: 'material',
                color: 'primary',
                icon: 'manage_accounts',
                tooltip: 'Cambiar estado de cuenta',
                click: (dato) => this.crearEstadoEntidad(dato),
                oculta() {
                  return HelperService.getTipoCliente() === 'Final';
                },
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Activos - Cambiar estado de cuenta',
                  ),
              },
            ],
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.activos$?.unsubscribe();
    this.reportes$?.unsubscribe();
  }
}
